import React from "react";
import Modal from "react-bootstrap/Modal";

const ModalLayoutFullScreen = ({ children, footer, moadlConfig, handleMoalClose, header }) => {
  return (
    <>
      <Modal
        // size={moadlConfig.size}
        aria-labelledby="contained-modal-title-vcenter"
        // centered
        show={moadlConfig.show}
        onHide={handleMoalClose}
        backdrop='static'
        keyboard={false}
        fullscreen={true}
      >
        <Modal.Header closeButton>
          {
            !!header
              ? header
              : <Modal.Title>{moadlConfig.title}</Modal.Title>
          }
        </Modal.Header>
        <Modal.Body>{children}</Modal.Body>
        {
          !!footer &&
          <Modal.Footer>
            {footer}
          </Modal.Footer>
        }
      </Modal>
    </>
  );
};

export default ModalLayoutFullScreen;
